export default __webpack_public_path__ + "static/media/airdockz-cbb-1.74468cf6.png";